import styles from "../GptAd.module.scss";

// This should only be used temporarily.
// Once the homepage is redesigned, modify GptAd settings
// with any relevant breakpoint changes, and
// use an appropriate ad component based on that.
export default function HomepageLeftRailAd() {
  return (
    <gpt-ad
      className={styles.root}
      targeting-pos="lrail"
      format="rrail"
      sizes-at-0=""
      sizes-at-1100="rail"
    ></gpt-ad>
  );
}
